import './App.css';
import React, { IframeHTMLAttributes, useEffect, useState } from 'react';
import Integration from './components/integration/index';
import { Request } from './utils/request'
import { jsonToQueryString, createH5SessionId, getAdPrams, getDeviceEnv } from './utils/tools';
import { SDKPoint, SDK_POINT } from './utils/sdkReport';
import { getDeviceId } from "./utils/deviceId";
import { UAParser } from 'ua-parser-js';

let query: any = new URLSearchParams(window.location.search);
const sessionId = query.get('sessionId') || createH5SessionId()
const logDebug= query.get('logDebug')
const zdinfo = query.get('zdinfo') ?? '';
const scope = query.get('scope') ?? '';
const scopeParams = query.get('scopeParams') ?? '';

// new vConsole()
/** 获取配置 */
const initPubInfo = ({ iwCode }: { iwCode: string }) => {
  return new Promise((resolve, reject) => {
    Request.create({
      url: process.env.REACT_APP_SDK_PUBSDKAPI_URL + '/sdk/client/h5shell',
      data: { iwCode },
      type: 'POST'
    }).then(res => {
      if (res?.code === 0) {
        SDKPoint.report(
          SDK_POINT.H5_SHELL_CONFIG_GET_SUCCESS,
          sessionId,
          Object.assign(
            res?.data || {},
            {
              openId: query.get('openid') || '',
              channelId: iwCode,
              trafficProvider: getAdPrams().traffic_provider,
              deviceModel: getDeviceEnv().device_model,
              deviceManufacturer: getDeviceEnv().device_manufacturer,
              gamePackageId: res?.data?.basePackageId || '',
              adId: res?.data?.adId || getAdPrams().traffic_adid
            }
          )
        )
        resolve(res?.data ?? {})
      }else {
        throw new Error();
      }
    }).catch((error: any) => {
      SDKPoint.report(
        SDK_POINT.H5_SHELL_CONFIG_GET_ERROR,
        sessionId,
        {
          openId: query.get('openid') || '',
          channelId: iwCode,
          trafficProvider: getAdPrams().traffic_provider,
          deviceModel: getDeviceEnv().device_model,
          deviceManufacturer: getDeviceEnv().device_manufacturer,
          adId: getAdPrams().traffic_adid
        }
      )
      console.error('获取pub信息失败', error)
      reject()
    })
  })
}

const App: React.FC = () => {
  const iwCode = query.get('iwCode');
  const [iframeUrl, setIframeUrl] = useState<string>();
  const [newIwCode, setNewIwCode] = useState<string>(iwCode);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState<string>();
  const init = async (iwCode: string) => {
    const shell = query.get('shell') ?? '';
    const code = query.get('code') ?? '';
    const state = query.get('state')?? '';
    const openid = query.get('openid') ?? '';
    const adinfo = query.get('ad') ?? '';
    const vdad = query.get('vdad') ?? '';
    let deviceEnv = query.get('deviceEnv') || '';
    if (!deviceEnv) {
      try {
        const { device, os } = UAParser(navigator.userAgent)
        deviceEnv = window.btoa(JSON.stringify({
          is_emu: '2',
          device_model: device.model,
          device_manufacturer: device.vendor,
          device_version: os.version,
          device_terminal: os.name,
          device_name: device.vendor + '' + device.model
        }))
      }
      catch(err) {
        console.log('err', err)
        deviceEnv = ''
      }
    }
    var id= getDeviceId();
    console.log("new_device_id3",id);
    const result: any = await initPubInfo({ iwCode });
    const { pubCode, mainBody, adId, gameName, gameBackgroundImage, gameUrl, pubPlatformCode,icon, basePackageId, sdkStatisticBehavior, logMode, glogVersion } = result ?? {}
    var miniIcon;
    var miniName;
    if (zdinfo !== '') {
      const zd = JSON.parse(window.atob(zdinfo));
      miniIcon = zd?.icon;
      miniName = zd?.name;
    }
    if(miniName){
      document.title = decodeURIComponent(miniName);
    }else{
      document.title = gameName;
    }
   
    setBackgroundImageUrl(gameBackgroundImage)
    setTimeout(() => {
      setBackgroundImageUrl('')
    }, 2000);
    const startWithQuestionMark = gameUrl?.indexOf('?') == -1
    const params = {
      "iwCode": iwCode,
      "shell": shell,
      "iw-pubCode": pubCode,
      "iw-channelId": iwCode,
      "iw-adId": adId,
      "iw-mainBody": mainBody,
      "iw-pubPlatformCode": pubPlatformCode,
      "code": code,
      "state": state,
      "zdinfo": zdinfo,
      "ad": adinfo,
      "openid":openid,
      "session_id": sessionId,
      "vdad": vdad,
      "deviceEnv": deviceEnv,
      "gamePackageId": basePackageId,
      "sdkStatisticBehavior": sdkStatisticBehavior === false ? '0' : '1',
      "logMode": logMode,
      "glogVersion": glogVersion,
      "scope": scope,
      "scopeParams": scopeParams ? encodeURIComponent(scopeParams) : ''
    }

  
    var gameIcon = icon;
    if(miniIcon){
      gameIcon = miniIcon;
    }

    if(gameIcon){
      const links = document.getElementsByTagName('link');
      let faviconLink = Array.from(links).find(link => link.getAttribute('rel') === 'icon');
      let appleFaviconLink = Array.from(links).find(link => link.getAttribute('rel') === 'apple-touch-icon');
      let appleFaviconLink2 = Array.from(links).find(link => link.getAttribute('rel') === 'apple-touch-icon-precomposed');
      if (faviconLink) {
        faviconLink.href = gameIcon;
      }
      if (appleFaviconLink) {
        appleFaviconLink.href = gameIcon;
      }
      if (appleFaviconLink2) {
        appleFaviconLink2.href = gameIcon;
      }
    }
    
    setIframeUrl(`${gameUrl}${jsonToQueryString(params, startWithQuestionMark)}${logDebug ? `&logDebug=${logDebug}` : ''}&deviceID=${id}`)
  }

  const onNewIwCodeChange = (e: any)=> {
    const value = e?.target?.value;
    setNewIwCode(value)
  }

  const onSubmit = ()=> {
    init(newIwCode);
  }

  useEffect(() => {
    if(process.env.REACT_APP_SDK_ENV === 'master'){
      init(iwCode)
    }
    // document.addEventListener('touchmove', (e) => {e.preventDefault()}, {passive: false})
  }, [])

  return (
    <>
      { (!iframeUrl && process.env.REACT_APP_SDK_ENV !== 'master') && <div className='block'>
        <input className='input' style={{ lineHeight: '0.5rem'}} type="text" value={newIwCode} onChange={onNewIwCodeChange} />
        <button className='submitBtn' style={{ height: '0.5rem', padding: '0.1rem'}} onClick={onSubmit}>确定</button>
      </div>}
      {  (iframeUrl || process.env.REACT_APP_SDK_ENV === 'master') && <div className='iframeBox'>
        <iframe id="lvanIframe" src={iframeUrl} frameBorder="0"></iframe>
        {backgroundImageUrl && <div style={{ position: 'absolute', width: '100%', height: '100%', zIndex: 1, left: 0, top: 0 }}>
          <img id="backgroundImg" width="100%" height="100%" max-width="100%" src={backgroundImageUrl} style={{ position: 'absolute', left: 0, top: 0 }} alt="" />
        </div>}
        <Integration />
      </div>}
    </>
  );
}
const basicSize: number = 100;
function setRem() {
  let width: number = window.innerWidth;
  const height: number = window.innerHeight;
  let rem: number = 0;
  console.log(`resize: width is ${width}, height is ${height}`)
  if (width > height) { // 横屏 规定设计尺寸为1334*750
    width = width < 750 ? 750 : width
    rem = width * basicSize / 1334;
  } else { // 竖屏 规定设计宽度为750
    rem = width * basicSize / 750;
  }
  if (rem > 100) {
    rem = 100;
  }
  document.documentElement.style.fontSize = rem + 'px';
}

function init() {
  setRem();
  document.addEventListener('DOMContentLoaded', setRem);
  window.addEventListener('resize', setRem);
  window.addEventListener('orientationchange', setRem);
}
init();
export default App;
